import axios from "axios";
import config from "../config/config";
import { getHeaders } from "./apiHelper";

const API_URL = config.API_URL; 

export const getRewardApproval = async () => {
    const res = await axios.get(`${API_URL}user-rule`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const getDetailRewardApproval = async (id) => {
    const res = await axios.get(`${API_URL}user-rule/${id}`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const updateRewardApproval = async (id, status, rejection_notes) => {
    const res = await axios.put(`${API_URL}user-rule/${id}`, { status, rejection_notes }, {
        headers: getHeaders(),
    });
    return res.data;
};

export const getPunishmentApproval = async () => {
    const res = await axios.get(`${API_URL}user-punishment`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const getDetailPunishmentApproval = async (id) => {
    const res = await axios.get(`${API_URL}user-punishment/${id}`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const updatePunishmentApproval = async (id, status, rejection_notes) => {
    const res = await axios.put(`${API_URL}user-punishment/${id}`, { status, rejection_notes }, {
        headers: getHeaders(),
    });
    return res.data;
};

export const getConsequenceApproval = async () => {
    const res = await axios.get(`${API_URL}user-consequence`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const getDetailConsequenceApproval = async (id) => {
    const res = await axios.get(`${API_URL}user-consequence/${id}`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const updateConsequenceApproval = async (id, status, rejection_notes) => {
    const res = await axios.put(`${API_URL}user-consequence/${id}`, { status, rejection_notes }, {
        headers: getHeaders(),
    });
    return res.data;
};

export const getCompensationApproval = async () => {
    const res = await axios.get(`${API_URL}user-compensation`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const getDetailCompensationApproval = async (id) => {
    const res = await axios.get(`${API_URL}user-compensation/${id}`, {
        headers: getHeaders(),
    });
    return res.data;
};

export const updateCompensationApproval = async (id, status, rejection_notes) => {
    const res = await axios.put(`${API_URL}user-compensation/${id}`, { status, rejection_notes }, {
        headers: getHeaders(),
    });
    return res.data;
};